/* =============================================
   URBAN UNSEEN — THEME JS
   ============================================= */

document.addEventListener('DOMContentLoaded', () => {

  // =============================================
  // PAGE LOADER
  // =============================================
  const loader = document.createElement('div');
  loader.className = 'page-loader';
  const logoSrc = document.querySelector('.logo-img')?.src || '';
  loader.innerHTML = `
    <img class="loader-logo" src="${logoSrc}" alt="Urban Unseen">
    <div class="loader-bar-wrap"><div class="loader-bar"></div></div>
  `;
  document.body.prepend(loader);

  window.addEventListener('load', () => {
    setTimeout(() => {
      loader.classList.add('hidden');
      setTimeout(() => loader.remove(), 700);
    }, 800);
  });

  // =============================================
  // CUSTOM CURSOR
  // =============================================
  const cursor = document.getElementById('cursor');
  const follower = document.getElementById('cursor-follower');

  if (cursor && follower) {
    let mouseX = 0, mouseY = 0;
    let followerX = 0, followerY = 0;

    document.addEventListener('mousemove', (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
      cursor.style.left = mouseX + 'px';
      cursor.style.top = mouseY + 'px';
    });

    function animateFollower() {
      followerX += (mouseX - followerX) * 0.12;
      followerY += (mouseY - followerY) * 0.12;
      follower.style.left = followerX + 'px';
      follower.style.top = followerY + 'px';
      requestAnimationFrame(animateFollower);
    }
    animateFollower();

    // Hover effects
    const hoverTargets = document.querySelectorAll('a, button, .product-card, .category-card, .filter-btn, .size-btn');
    hoverTargets.forEach(el => {
      el.addEventListener('mouseenter', () => {
        cursor.classList.add('hovering');
        follower.classList.add('hovering');
      });
      el.addEventListener('mouseleave', () => {
        cursor.classList.remove('hovering');
        follower.classList.remove('hovering');
      });
    });
  }

  // =============================================
  // HEADER SCROLL
  // =============================================
  const header = document.getElementById('site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 50) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    }, { passive: true });
  }

  // =============================================
  // MOBILE MENU
  // =============================================
  const hamburger = document.getElementById('hamburger');
  const mobileMenu = document.getElementById('mobile-menu');

  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', () => {
      mobileMenu.classList.toggle('active');
      const spans = hamburger.querySelectorAll('span');
      hamburger.classList.toggle('open');
      if (hamburger.classList.contains('open')) {
        spans[0].style.transform = 'rotate(45deg) translate(5px, 5px)';
        spans[1].style.opacity = '0';
        spans[2].style.transform = 'rotate(-45deg) translate(5px, -5px)';
      } else {
        spans[0].style.transform = '';
        spans[1].style.opacity = '';
        spans[2].style.transform = '';
      }
    });
  }

  // =============================================
  // STAR FIELD GENERATION
  // =============================================
  const heroStars = document.querySelector('.hero-stars');
  if (heroStars) {
    for (let i = 0; i < 80; i++) {
      const star = document.createElement('div');
      star.className = 'star';
      const size = Math.random() * 3 + 1;
      star.style.cssText = `
        width: ${size}px;
        height: ${size}px;
        left: ${Math.random() * 100}%;
        top: ${Math.random() * 100}%;
        --duration: ${Math.random() * 3 + 2}s;
        --delay: ${Math.random() * 4}s;
        opacity: ${Math.random() * 0.5 + 0.2};
      `;
      heroStars.appendChild(star);
    }
  }

  // =============================================
  // SCROLL REVEAL
  // =============================================
  const reveals = document.querySelectorAll('.reveal');
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry, index) => {
      if (entry.isIntersecting) {
        setTimeout(() => {
          entry.target.classList.add('visible');
        }, index * 60);
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });

  reveals.forEach(el => revealObserver.observe(el));

  // =============================================
  // PRODUCT FILTER (Homepage)
  // =============================================
  const filterBtns = document.querySelectorAll('.filter-btn');
  filterBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      filterBtns.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
    });
  });

  // =============================================
  // NEWSLETTER FORM
  // =============================================
  document.querySelectorAll('.newsletter-form').forEach(form => {
    const btn = form.querySelector('.newsletter-btn');
    const input = form.querySelector('.newsletter-input');
    if (btn && input) {
      btn.addEventListener('click', () => {
        if (input.value && input.value.includes('@')) {
          btn.textContent = '✓';
          btn.style.background = '#1a1a1a';
          btn.style.color = '#fff';
          input.value = '';
          input.placeholder = 'WELCOME TO THE UNSEEN';
          setTimeout(() => {
            btn.textContent = '→';
            btn.style.background = '';
            btn.style.color = '';
            input.placeholder = 'YOUR EMAIL';
          }, 3000);
        }
      });
    }
  });

  // =============================================
  // SMOOTH HOVER — product cards
  // =============================================
  document.querySelectorAll('.product-card').forEach(card => {
    card.addEventListener('mousemove', (e) => {
      const rect = card.getBoundingClientRect();
      const x = (e.clientX - rect.left) / rect.width - 0.5;
      const y = (e.clientY - rect.top) / rect.height - 0.5;
      card.style.transform = `perspective(800px) rotateY(${x * 3}deg) rotateX(${-y * 3}deg)`;
    });
    card.addEventListener('mouseleave', () => {
      card.style.transform = '';
    });
  });

  // =============================================
  // CHROME SHIMMER on Logo
  // =============================================
  const logoImgs = document.querySelectorAll('.logo-img, .footer-logo, .hero-logo-img');
  logoImgs.forEach(img => {
    let frame;
    img.addEventListener('mouseenter', () => {
      let intensity = 0;
      const animate = () => {
        intensity = Math.min(intensity + 0.08, 1);
        img.style.filter = `drop-shadow(0 0 ${20 * intensity}px rgba(192,192,192,0.6)) drop-shadow(0 0 ${60 * intensity}px rgba(255,255,255,0.3))`;
        if (intensity < 1) frame = requestAnimationFrame(animate);
      };
      animate();
    });
    img.addEventListener('mouseleave', () => {
      cancelAnimationFrame(frame);
      let intensity = 1;
      const animate = () => {
        intensity = Math.max(intensity - 0.06, 0);
        img.style.filter = `drop-shadow(0 0 ${20 * intensity}px rgba(192,192,192,0.4)) drop-shadow(0 0 ${60 * intensity}px rgba(255,255,255,0.15))`;
        if (intensity > 0) frame = requestAnimationFrame(animate);
      };
      animate();
    });
  });

  // =============================================
  // Size selector (product page)
  // =============================================
  document.querySelectorAll('.size-btn:not(.unavailable)').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.size-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
    });
  });

  // =============================================
  // Cart count animation
  // =============================================
  document.querySelectorAll('.add-to-cart-btn, .quick-add-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const cartCount = document.querySelector('.cart-count');
      if (cartCount) {
        cartCount.style.transform = 'scale(1.5)';
        cartCount.style.background = '#ffffff';
        setTimeout(() => {
          cartCount.style.transform = '';
        }, 300);
      }
    });
  });

});
